<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-accordion-docs-preview></ui-accordion-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-accordion</span> [<span class="hljs-attr">allowMultipleExpanded</span>]=<span class="hljs-string">"false"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-accordion-item</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let elem of arrayOfAccordions"</span>
        <span class="hljs-attr">icon</span>=<span class="hljs-string">"icon"</span>
        <span class="hljs-attr">header</span>=<span class="hljs-string">"header"</span>
        [<span class="hljs-attr">expanded</span>]=<span class="hljs-string">"false"</span>&gt;</span>
        content
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-accordion-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-accordion</span>&gt;</span></code></pre>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-accordion</span> [<span class="hljs-attr">allowMultipleExpanded</span>]=<span class="hljs-string">"false"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-accordion-item</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let elem of arrayOfAccordions"</span>
        [<span class="hljs-attr">expanded</span>]=<span class="hljs-string">"false"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ng-template</span> <span class="hljs-attr">ui-accordion-header-template</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"custom"</span>&gt;</span>
                <span class="hljs-tag">&lt;<span class="hljs-name">ui-flag</span> <span class="hljs-attr">culture</span>=<span class="hljs-string">"se"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"tiny"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-flag</span>&gt;</span> &amp;nbsp;
                <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"text"</span>&gt;</span>Custom header<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
                <span class="hljs-tag">&lt;<span class="hljs-name">ui-icon</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"loop"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-icon</span>&gt;</span>
                <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"text"</span>&gt;</span>template<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
            <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ng-template</span>&gt;</span>
        {{ '{' }}{{ '{' }} elem.content {{ '}' }}{{ '}' }}
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-accordion-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-accordion</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">allowMultipleExpanded</td>
<td align="left">When false only one accordion is expanded per time, if true multiple accordions can be expanded.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
